import { ApplicationUser } from '@/types/application-user';
import { isUserPlatformAdmin } from '../is-user-platform-admin';

export const canActiveUserAssignAnyOrganisation = (
  activeUser: ApplicationUser,
  isUsingOrganisationOverride: boolean,
): boolean => {
  // Only Platform Admin can assign any organisation
  if (isUserPlatformAdmin(activeUser)) {
    // Enforce platform Admin ot assign the current organisation when in the nested Organisation view
    return isUsingOrganisationOverride === false;
  }

  return false;
};
